/**
 * HTTP method override Interceptor.
 */

module.exports = function (_) {

    return {

        request: function (request) {

            if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
                request.headers['X-HTTP-Method-Override'] = request.method;
                request.method = 'POST';
            }

            return request;
        }

    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/interceptor/method.js
// module id = 226
// module chunks = 1